<template>
  <div class="main tabs_main" style="height:89%">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">物品名称：</span>
        <el-select v-model="search.assistId" placeholder="请选择物品型号" clearable>
            <el-option
            v-for="item in optionsAuxiliary"
            :key="item.id"
            :label="item.assistName+'-'+item.assistModel"
            :value="item.id">
            </el-option>
        </el-select>
      </div>
      <!-- <div class="header_item">
        <span class="header_label">规格型号：</span>
        <el-select v-model="search.supplierType" placeholder="请选择规格型号">
            <el-option
            v-for="item in optionsModels"
            :key="item.dictId"
            :label="item.dictName"
            :value="item.dictId">
            </el-option>
        </el-select>
      </div> -->
      <div class="header_item">
        <span class="header_label">领料部门：</span>
        <el-input v-model="search.getDepart" :size="size" clearable placeholder="请输入领料部门"></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">时间范围：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            :default-time="['00:00:00','23:59:59']"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
        <el-button  icon="el-icon-upload2" v-if="showButton('export')" @click="exportOutData">导出Excel</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="assistName" label="物品名称" align="center" width="180"></el-table-column>
        <el-table-column prop="assistModel" label="规格型号" align="center" width="120"></el-table-column>
        <el-table-column prop="changeStock" label="出库数量" align="center" ></el-table-column>
        <el-table-column prop="singlePrice" label="单价" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="amount" label="金额" align="center" ></el-table-column>
        <el-table-column prop="realName" label="发料人" align="center" ></el-table-column>
        <el-table-column prop="departName" label="领料部门" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="出库时间" align="center"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <!-- <el-button class="table_btn" size="mini"  v-if="showButton('update')" @click="updateProp(row)">修改</el-button> -->
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增出库' : '修改出库信息'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="物品型号：" prop="assistId">
          <el-select v-model="ruleForm.assistId" :size="size" placeholder="请选择物品型号">
            <el-option
            v-for="item in optionsAuxiliary"
            :key="item.id"
            :label="item.assistName+'-'+item.assistModel"
            :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="入库时间：" prop="createTime">
          <el-date-picker
            v-model="ruleForm.createTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :size="size"
            clearable
            placeholder="请选择入库时间">
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="出库数量：" prop="changeStock">
          <el-input v-model="ruleForm.changeStock" :size="size" type="number" clearable placeholder="请输入出库数量"></el-input>
        </el-form-item>
        <el-form-item label="领料部门：" prop="getDepart">
            <el-select v-model="ruleForm.getDepart" placeholder="请选择领料部门">
                <el-option
                v-for="item in optionsDeparts"
                :key="item.departId"
                :label="item.departName"
                :value="item.departId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="单价：" prop="singlePrice">
          <el-input v-model="ruleForm.singlePrice" type="number" :size="size" clearable placeholder="请输入单价" @blur="priceChange"></el-input>
        </el-form-item>
        <el-form-item label="金额：" prop="amount">
          <el-input v-model="ruleForm.amount" :size="size" clearable placeholder="请输入金额" :disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input v-model="ruleForm.remark" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../pinia/index';
import { throttle, changeSize,downFiles } from '../../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        disabled:false,//是否禁止修改
        dataList: [], //入库记录信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
        }, // 按钮表单
        rules: {
          assistId: [{
            required: true,
            message: '请选择物品型号',
            trigger: 'change'
          }],
          changeStock: [{
            required: true,
            message: '请输入出库数量',
            trigger: 'blur'
          }],
          getDepart: [{
            required: true,
            message: '请选择领料部门',
            trigger: 'change'
          }],
          singlePrice: [{
            required: true,
            message: '请输入单价',
            trigger: 'blur'
          }],
          amount: [{
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }],
        },
        optionsAuxiliary:[],//物品名称
        optionsDeparts:[],//领料部门
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getAllDeparts()
    },
    methods: {
    //导出数据
    exportOutData(){
        this.functionLoading();
        let params  = Object.assign({},this.search,{
            stockType:2
        })
        this.$api.Auxiliary.exportOutDatas(params).then(res => {
            downFiles(res, '出库记录信息', 'xls')
            this.loadingView.close()
        })
        .catch(() => {
          this.loadingView.close();
        })
    },
    //计算金额
    priceChange(){
      console.log(this.ruleForm.singlePrice,'******',this.ruleForm.changeStock,'大白话')
      if(this.ruleForm.changeStock !==undefined &&this.ruleForm.changeStock!==undefined){
        this.$set(this.ruleForm,'amount',this.ruleForm.singlePrice*1*this.ruleForm.changeStock)
      }else{
        this.$set(this.ruleForm,'amount',' ')
      }
    },
    //获取所有辅材名称
      getNameList(){
        let params = {
            pageNum: 1,
            pageSize: 100000000
        }
        this.$api.Auxiliary.searchAuxiliaryType(params).then(res=>{
            if(res.statusMsg ==='ok'){
                this.optionsAuxiliary = res.data.list
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
    //获取领料部门信息
      getAllDeparts(){
        this.$api.Personnerl.GETDEPARTMENTDATA({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsDeparts = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 转圈圈
      functionLoading() {
        this.loadingView = this.$loading({
          lock: true,
          text: '请稍后...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          stockType:2
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Auxiliary.searchAuxiliaryOut(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }else{
            this.$message.warning(res.statusMsg)
          }
          this.loading = false;
        })
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.disabled = true
        this.$api.Rebar.detailsType({steelId: row.steelId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.disabled = true
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Auxiliary.deleteAuxiliaryOut({id: row.id,stockType:2})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.changeStock = this.ruleForm.changeStock*1
            params.singlePrice = this.ruleForm.singlePrice*1
            params.stockType = 2
            this.$api.Auxiliary.insertAuxiliaryOut(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../../style/layout-main.scss';
</style>